<template>
    <div class="store-location-list">
        <!-- message asking for users to search for a location -->
        <div v-if="nearLocations.length == 0" class="ion-margin-horizontal">
            <h5 class="ion-text-center please-search-text">Our menu and offers vary by location. <br />Search to find a Donatos near you:</h5>
        </div>

        <locationSearch v-if="searchBar" class="ion-hide-lg-down ion-margin-horizontal" data-cy="desktop-search" />
        <div v-if="searchError" class="ion-margin ion-text-center">
            <span>{{ searchError }}</span>
        </div>

        <div v-else-if="searchProcessing" class="ion-margin">
            <div v-for="(_, i) in new Array(10)" :key="i" class="ion-margin-vertical ion-padding-top">
                <dynamicSkeleText element="div" :childElements="skeleText" :animate="i % 3 == 0" />
                <ion-item-divider class="ion-margin-vertical" />
            </div>
        </div>

        <div v-else>
            <div v-for="location in sort(nearLocations)" :key="location.id" class="grey-highlight">
                <locationLineItem :storeLocation="location" clickable class="ion-padding-vertical" />
                <ion-item-divider />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import locationLineItem from '@/components/locationLineItem.vue';
import { useStore } from 'vuex';
import { IonItemDivider } from '@ionic/vue';
import locationSearch from '@/components/locationSearch.vue';
import { skeleText } from '@/models/props/skeleText';
import dynamicSkeleText from '@/components/dynamicSkeleText.vue';

export default defineComponent({
    components: { locationLineItem, IonItemDivider, locationSearch, dynamicSkeleText },
    props: { searchBar: Boolean },
    setup() {
        const store = useStore();
        const sort = (locations) => locations.sort((a, b) => b.highlighted - a.highlighted);
        const searchError = computed(() => store.getters.getSearchError);
        const searchProcessing = computed(() => store.getters.processingNearLocations);
        const skeleText: skeleText[] = [{ width: 60, height: '15px' }, { width: 90 }, { width: 20, display: 'inline-block' }];

        return {
            nearLocations: computed(() => store.getters.getLimitedNearLocations),
            sort,
            searchError,
            searchProcessing,
            skeleText,
        };
    },
});
</script>

<style scoped>
@media screen and (max-width: 960px) {
    .store-location-list {
        max-height: 60vh;
        padding-bottom: 50px;
    }
}
.grey-highlight:hover {
    background-color: var(--ion-color-light);
}
.please-search-text {
    color: var(--ion-color-dark);
    font-size: 1.2em;
    margin-top: 11px;
}
</style>
